module.exports = __webpack_public_path__ + "static/media/logo-visa.39b4ca00.svg";